import React, { Component } from 'react'
import './styles.scss'
import { withTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

class Footer extends Component {

  onPrivacySettingsClick = () => {
    if (window.hasOwnProperty('CCM')) {
      window.CCM.openWidget()
    }
    return false
  }

  render () {
    const { t } = this.props
    return (
      <footer className="mygiata_footer">
        <div className="mygiata_footer_top">
          <nav className="mygiata_footer_navi">
            <ul>
              <li><a href={t('URL_LEGAL_NOTICE')} rel="noreferrer"
                     target="_blank">{t('LEGAL_NOTICE')}</a></li>
              <li><a href={t('URL_PRIVACY_POLICY')} rel="noreferrer"
                     target="_blank">{t('PRIVACY_POLICY')}</a></li>
              <li><a href={t('URL_CONTACT')} rel="noreferrer"
                     target="_blank">{t('CONTACT_US')}</a></li>
              <li><Link to="/cancellation">{t('CANCEL_SUBSCRIPTION')}</Link></li>
              <li>
                <span onClick={this.onPrivacySettingsClick} className={'Link'}>{t('PRIVACY_SETTINGS')}</span>
              </li>
            </ul>
          </nav>
          <div className="mygiata_copyright">&copy; GIATA GmbH - {t('ALL_RIGHTS_RESERVED')}</div>
        </div>
      </footer>
    )
  }
}

export default withTranslation()(Footer)
